import useSWRV from "swrv";
import { axios, fetcher } from "/@/modules/axios";
import { errorHandle } from "/@/modules/error";
import { Notification } from "/@/types/user";

export function notificationTypeLabel(
  actionType: Notification["actionType"]
): string {
  switch (actionType) {
    case "new_inquiry":
      return "新しいお問い合わせ";
    case "new_inquiry_reply":
      return "お問い合わせの新しい返信";
    case "new_registration":
      return "新しい登録";
    case "update_user_info":
      return "ユーザー情報の更新";
    case "unsubscribe_user":
      return "ユーザーの退会";
    default:
      return "不明な通知";
  }
}
